/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import Modal from '@carvana/showroom-modal';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import TertiaryButton from '@carvana/showroom-forms/Button/Tertiary';
import TextArea from '@carvana/showroom-forms/Input/TextArea';
import { Form } from 'formik';

const PrePurchaseModal = styled(Modal)`
  .modal--content {
    background: var(--cvna-color-white);
    text-align: center;
  }

  .modal--scroll-area {
    margin: 0;
  }
`;

const PrePurchaseModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CancellationPrompt = styled(PrePurchaseModalContent as any)``;

const BodyHeader = styled.h2`
  color: var(--cvna-color-blue-6);
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  margin: 0 auto 24px auto;
  max-width: 310px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 500px;
  }
`;

const BodyText = styled.p<{ maxWidth: any }>`
  color: var(--cvna-color-grey-5);
  margin-bottom: 16px;
  max-width: 280px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  &:last-of-type {
    margin-bottom: 32px;
  }

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: ${(props) => props.maxWidth}px;
  }
`;

const ConfirmationText = styled(BodyText as any)`
  margin-top: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
`;

const CancellationSuccess = styled(PrePurchaseModalContent as any)``;

const IconContainer = styled.div<{ marginTop: any; marginBottom: any }>`
  margin-top: ${(props) => props.marginTop}; //55px;
  margin-bottom: ${(props) => props.marginBottom}; //46px;
`;

const CancellationFailure = styled(PrePurchaseModalContent as any)``;

const CustomForm = styled(Form)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const CustomTextArea = styled(TextArea)`
  max-width: 448px;
  margin-bottom: 24px;

  & textarea {
    padding: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  & .input__caption {
    display: none;
  }

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 32px;
  }
`;

const ButtonContainer = styled.div<{ marginRight: any }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-bottom: 48px;

  & > button:first-of-type {
    margin-bottom: 8px;
  }

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    justify-content: center;
    margin-right: ${(props) => props.marginRight}; //20px;
    & > button:first-of-type {
      // margin-bottom: 0;
    }
  }
`;

const CustomPrimaryButton = styled(PrimaryButton)`
  // width: 100%;
  width: 274px;
  min-width: unset !important;
  min-height: 48px !important;
  padding: 0 18px !important;
  font-size: 14px !important;
  line-height: 16px !important;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 236px;
  }
`;

const CustomTertiaryButton = styled(TertiaryButton)`
  width: auto;
  min-width: unset;
  min-height: 48px !important;
  padding: 0 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  text-align: left;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-left: 24px !important;
  }
`;

export {
  PrePurchaseModal,
  PrePurchaseModalContent,
  CancellationPrompt,
  BodyHeader,
  BodyText,
  ConfirmationText,
  CancellationSuccess,
  IconContainer,
  CancellationFailure,
  CustomForm,
  CustomTextArea,
  ButtonContainer,
  CustomPrimaryButton,
  CustomTertiaryButton,
};
